/* **************************************************** Finishing Shedule Size */
export interface FSSize {
    id: number;
    category: string;
    size_name: string;
    created_by: number | null;
}

export const mapFSSize = (data: any): FSSize => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSSize = {
        id: data.id,
        category: data.category,
        size_name: data.size_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSSizes = (data: any[]): FSSize[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSSize);
};
